import { z } from "zod"

export enum FlightRecordStatus {
    Error = "error",
    WaitingForUpload = "waiting_for_upload",
    Duplicate = "duplicate",
    Processing = "processing",
    Processed = "processed",
}

export enum DroneManufacturer {
    DJI = "dji",
    Autel = "autel",
    Parrot = "parrot",
    Skydio = "skydio",
}

export const FlightRecordMetadataRecordSchema = z.object({
    orgId: z.string(),
    fileId: z.string(),
    fileName: z.string(),
    status: z.enum(FlightRecordStatus),
    manufacturer: z.enum(DroneManufacturer),
})

export const FlightRecordMetadataRecordsSchema = z.array(FlightRecordMetadataRecordSchema)

export const FlightRecordMetadataRecordOptionalSchema = FlightRecordMetadataRecordSchema.optional()

export const FlightRecordMetadataRecordsOptionalSchema = z.array(
    FlightRecordMetadataRecordOptionalSchema
)

export type FlightRecordMetadataRecord = z.infer<typeof FlightRecordMetadataRecordSchema>

export const isValidDroneManufacturer = (manufacturer: DroneManufacturer) =>
    FlightRecordMetadataRecordSchema.shape.manufacturer.safeParse(manufacturer).success
